var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.39 18.75a.625.625 0 0 1-.366-.118L10 14.99l-5.024 3.642a.625.625 0 0 1-.959-.706l1.96-5.803L.899 8.64A.625.625 0 0 1 1.25 7.5h6.265l1.89-5.819a.625.625 0 0 1 1.19 0l1.89 5.82h6.265a.624.624 0 0 1 .354 1.141l-5.08 3.48 1.958 5.802a.624.624 0 0 1-.591.826Z",
    fill: "currentColor"
  })));
};
export { SvgStar as ReactComponent };